import { render } from "./FakeBrowser.vue?vue&type=template&id=4320438e&scoped=true"
import script from "./FakeBrowser.vue?vue&type=script&lang=js"
export * from "./FakeBrowser.vue?vue&type=script&lang=js"

import "./FakeBrowser.vue?vue&type=style&index=0&id=4320438e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4320438e"],['__file',"src/scripts/portfolioManager/onboarding/FakeBrowser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4320438e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4320438e', __exports__)) {
    api.reload('4320438e', __exports__)
  }
  
  module.hot.accept("./FakeBrowser.vue?vue&type=template&id=4320438e&scoped=true", () => {
    api.rerender('4320438e', render)
  })

}


export default __exports__